import { render, staticRenderFns } from "./CardRejectedSM.vue?vue&type=template&id=f94550cc&scoped=true"
import script from "./CardRejectedSM.vue?vue&type=script&lang=js"
export * from "./CardRejectedSM.vue?vue&type=script&lang=js"
import style0 from "./CardRejectedSM.vue?vue&type=style&index=0&id=f94550cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94550cc",
  null
  
)

export default component.exports